import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
}
export function FadeIn({
  children,
  delay = 0,
  direction = 'up',
  className = ''
}: FadeInProps) {
  const directions = {
    up: {
      y: 40,
      x: 0
    },
    down: {
      y: -40,
      x: 0
    },
    left: {
      x: 40,
      y: 0
    },
    right: {
      x: -40,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  return <motion.div initial={{
    opacity: 0,
    ...directions[direction]
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay: delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-155">
      {children}
    </motion.div>;
}